export const eventPrices = {
  starter: {
    total: 35,
    perMonth: 35,
    period: 'event'
  },
  pro100: {
    total: 69,
    perMonth: 69,
    period: 'event'
  },
  pro250: {
    total: 99,
    perMonth: 99,
    period: 'event'
  },
  pro500: {
    total: 199,
    perMonth: 199,
    period: 'event'
  },
  pro1000: {
    total: 299,
    perMonth: 299,
    period: 'event'
  }
}

export const monthlyPrices = {
  starter: {
    total: 35,
    perMonth: 35,
    period: 'month'
  },
  pro100: {
    total: 69,
    perMonth: 69,
    period: 'month'
  },
  pro250: {
    total: 99,
    perMonth: 99,
    period: 'month'
  },
  pro500: {
    total: 199,
    perMonth: 199,
    period: 'month'
  },
  pro1000: {
    total: 299,
    perMonth: 299,
    period: 'month'
  }
}

export const yearlyPrices = {
  starter: {
    total: 96,
    perMonth: 8,
    period: 'year'
  },
  pro100: {
    total: 192,
    perMonth: 16,
    period: 'year'
  },
  pro250: {
    total: 288,
    perMonth: 24,
    period: 'year'
  },
  pro500: {
    total: 456,
    perMonth: 38,
    period: 'year'
  },
  pro1000: {
    total: 780,
    perMonth: 65,
    period: 'year'
  }
}

export const yearlyEduPrices = {
  starter: {
    total: 72,
    perMonth: 6,
    period: 'year'
  },
  pro100: {
    total: 132,
    perMonth: 11,
    period: 'year'
  },
  pro250: {
    total: 198,
    perMonth: 16.5,
    period: 'year'
  },
  pro500: {
    total: 312,
    perMonth: 26,
    period: 'year'
  },
  pro1000: {
    total: 528,
    perMonth: 44,
    period: 'year'
  }
}

export const testPriceIds = {
  monthly: { // updated 10/16/2023
    starter: 'price_1O0TwNA378qsFcNylM8ylKWB', // $35/mo
    pro100: 'price_1O0UEkA378qsFcNyVtNZ9KyR', // $69/mo
    pro250: 'price_1O0UE4A378qsFcNyyKhAZtbX', // $99/mo
    pro500: 'price_1O0UDJA378qsFcNyCRGYqeuv', // $199/mo
    pro1000: 'price_1O0UBgA378qsFcNyiocrsGHJ' // $299/mo
  },
  oneTime: {
    starter: 'price_1Jr5wuA378qsFcNylw9sz2p1', // updated 11/01/2021
    pro100: 'price_1MEZNjA378qsFcNy408MVMyU',
    pro250: 'price_1Jr5xXA378qsFcNyvK4D2MGA', // updated 11/01/2021
    pro500: 'price_1LcYfkA378qsFcNyGwt0npRg',
    pro1000: 'price_1LcYfyA378qsFcNyj5Wefh9A'
  },
  yearly: { // updated 10/16/2023
    starter: 'price_1JqisOA378qsFcNyTzuU0S88', // $96/yr
    pro100: 'price_1MEZOPA378qsFcNy7icnEBs0', // $192/yr
    pro250: 'price_1JqisCA378qsFcNyHmbYGBal', // $288/yr
    pro500: 'price_1LcYTNA378qsFcNyvpEo1GOb', // $456/yr
    pro1000: 'price_1LcYULA378qsFcNyg0CTt9sT' // $780/yr
  },
  yearlyEdu: { // all updated on 1/11/2023
    starter: 'price_1IcsxSA378qsFcNyuidGdZhL', // $72/yr
    pro100: 'price_1MP4e8A378qsFcNyOCa4KXdT', // $132/yr
    pro250: 'price_1MP4gaA378qsFcNyWR1KUHmV', // $198/yr
    pro500: 'price_1MP4hHA378qsFcNyJxipchAy', // $312/yr
    pro1000: 'price_1MP4m6A378qsFcNyDTszaVos' // $528/yr
  }
}

export const livePriceIds = {
  monthly: { // updated 10/16/2023
    starter: 'price_1O09TDA378qsFcNyX8W1LxSO', // $35/mo
    pro100: 'price_1O09IpA378qsFcNyZMGwtiG8', // $69/mo
    pro250: 'price_1O0MZGA378qsFcNy86Epyy8z', // $99/mo
    pro500: 'price_1O0MjmA378qsFcNyAD7pTK3y', // $199/mo
    pro1000: 'price_1O0MkcA378qsFcNysZf6YxhJ' // $299/mo
  },
  oneTime: {
    starter: 'price_1Jr22fA378qsFcNyewNgk6WV', // updated 11/01/2021
    pro100: 'price_1MEZISA378qsFcNy6gyTmsm2',
    pro250: 'price_1Jr23TA378qsFcNyl1s7rSPn', // updated 11/01/2021
    pro500: 'price_1LaiAOA378qsFcNyiCPW6XeP', // added 8/25/2022
    pro1000: 'price_1LaiEgA378qsFcNyFXVTl1Dy'
  },
  yearly: { // updated 11/8/2023
    starter: 'price_1JqirCA378qsFcNy8PSsZ1gG', // $96/yr
    pro100: 'price_1MEZJqA378qsFcNy8fHDNmwV', // $192/yr
    pro250: 'price_1JqipaA378qsFcNysT9g1Ctr', // $288/yr
    pro500: 'price_1LaiGtA378qsFcNyf4LUCZoX', // $456/yr
    pro1000: 'price_1LaiHxA378qsFcNyAVoXzexx' // $780/yr
  },
  yearlyEdu: { // updated on 10/16/2023
    starter: 'price_1IYCu4A378qsFcNymqq2mc46', // $72/yr
    pro100: 'price_1MP3YoA378qsFcNy4Bc1kqfr', // $132/yr
    pro250: 'price_1MP4LiA378qsFcNyv4Wb39ae', // $198/yr
    pro500: 'price_1MP4JnA378qsFcNy3qG24bWI', // $312/yr
    pro1000: 'price_1MP4JCA378qsFcNyc2BmlrIZ' // $528/yr
  }
}

export function getNameFromPrice (num) {
  // loop through eventPrices object for a price that matches num,
  // then return the key and period of that price as the plan name
  // to be passed to stripe
  for (const key in eventPrices) {
    if (eventPrices[key].total === num) {
      const matches = key.match(/([a-z]+)(\d+)?/)
      let planName = matches[1]
      if (matches[2]) { planName += ' ' + matches[2] }
      return planName + ' event pass'
    }
  }

  // repeat loop for yearlyPrices
  for (const key in yearlyPrices) {
    if (yearlyPrices[key].total === num) {
      const matches = key.match(/([a-z]+)(\d+)?/)
      let planName = matches[1]
      if (matches[2]) { planName += ' ' + matches[2] }
      return planName + ' yearly'
    }
  }

  // repeat loop for yearlyEduPrices
  for (const key in yearlyEduPrices) {
    if (yearlyEduPrices[key].total === num) {
      const matches = key.match(/([a-z]+)(\d+)?/)
      console.log(matches)
      let planName = matches[1]
      if (matches[2]) { planName += ' ' + matches[2] }
      return planName + ' edu yearly'
    }
  }
}
